import { Row, Col } from "reactstrap";
import { Button } from "antd";
import { useState } from "react";
import { motion } from "framer-motion";
import { BulbTwoTone } from "@ant-design/icons";
import verifyIdentity from "../../../assets/images/DigitalIdentityVerification.png";
import "../utils/newMerchant.css";
import { logout } from "../../auth/services/authApi";
import AddDocVerify from "../component/addDocVerify";
import { useNavigate } from "react-router-dom";


const NewMerchant = () => {
  
  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
  const [currentUserState, setCurrentUserState] = useState(currentUser);
  const [kycModal, setKycModal] = useState(false);

  const kycStatus = currentUserState?.kycStatus;
  const kycVerified = currentUserState?.user?.kycVerified;
  const navigate = useNavigate();

  console.log('currentUser',currentUser)

  return (
    <div className="text-center new-merchant-container">
      <Row className="merchant-content ">
        <Col xs="12" sm="12" md="8" className="text-center mx-auto">

          <motion.div
            className="new-merchant-image mb-1"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <img src={verifyIdentity} alt="Vérification identité" />
          </motion.div>

          <motion.h2
            className="verify"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
          >
            Vérification d’identité
          </motion.h2>

          {!kycVerified ? (
            kycStatus === "NOT_SUBMITTED" ? (
              <>
                <motion.p
                  className="new-merchant-description"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5, duration: 0.6 }}
                >
                  Pour garantir la sécurité de votre compte et respecter les
                  <span style={{ display: "block", marginLeft: "2px" }}>
                    réglementations financières, nous devons vérifier votre
                  </span>
                  <span style={{ display: "block", marginLeft: "2px" }}>
                    identité avant que vous puissiez utiliser nos services.
                  </span>
                </motion.p>

                <motion.div
                  className="verification-box"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6, duration: 0.6 }}
                >
                  <div className="verification-title">
                    <BulbTwoTone />
                    <span> Pourquoi cette vérification est-elle nécessaire ?</span>
                  </div>

                  <ul className="verification-list">
                    <li>Conformité aux réglementations financières</li>
                    <li>Protection contre la fraude et le blanchiment d'argent</li>
                    <li>Sécurisation de vos transactions et de vos fonds</li>
                    <li>Accès à toutes les fonctionnalités de paiement</li>
                  </ul>
                </motion.div>
              </>
            ) : 
            kycStatus === "SUBMITTED" ? (
              <motion.div
                className="kyc-success-container"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.3 }}
                  style={{ marginTop: 10, color: "#faad14" }}
                >
                  ⏳ Vérification en cours...
                </motion.div>

                <p className="new-merchant-description">
                  Merci d'avoir soumis vos documents.
                  <br /><br />
                  Vous recevrez une réponse mail dans les plus brefs délais.
                </p>

                <div className="verification-box mt-3">
                  <div className="verification-title">
                    <BulbTwoTone />
                    <span>Besoin d’aide ?</span>
                  </div>

                  <p style={{ marginTop: 10 }}>
                    Si nécessaire, vous pouvez contacter notre support Paxity :
                  </p>

                  <p>
                    📧 contact@paxity.io <br />
                    📞 +221 78 784 80 80
                  </p>
                </div>
              </motion.div>
            ) : 
            kycStatus === "REJECTED" ? (
              <motion.div
                className="kyc-success-container"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.3 }}
                  style={{ marginTop: 10, color: "red" }}
                >
                  ❌ Vérification terminée
                </motion.div>

                <p className="new-merchant-description">
                  Malheureusement les documents ont été rejetés.
                  <br />
                  Pour plus de sécurité, le motif vous a été envoyé par mail.
                </p>

                <p className="new-merchant-description">
                  Vous pouvez soumettre à nouveau les bons documents.
                </p>

                {/* <div className="verification-box mt-3">
                  <div className="verification-title">
                    <BulbTwoTone />
                    <span>Besoin d’aide ?</span>
                  </div>

                  <p style={{ marginTop: 10 }}>
                    Si nécessaire, vous pouvez contacter notre support Paxity :
                  </p>

                  <p>
                    📧 contact@paxity.io <br />
                    📞 +221 33 822 83 30
                  </p>
                </div> */}
              </motion.div>
            ) : 
            kycStatus === "APPROUVE" ? (
              <motion.div
                className="kyc-success-container"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.3 }}
                  style={{ marginTop: 10, color: "green" }}
                >
                  ✅ Vérification terminée
                </motion.div>

                <p className="new-merchant-description">
                  Bravo les documents ont été validés avec succès
                  <br /><br />
                  Vous pouvez explorer toutes nos fonctionnalités
                </p>

                <div className="verification-box mt-3">
                  <div className="verification-title">
                    <BulbTwoTone />
                    <span>Information</span>
                  </div>

                  <p style={{ marginTop: 10 }}>
                    Votre compte est entièrement actif.
                  </p>
                </div>
              </motion.div>
            ) : null
          ) : (
            <div className="verification-box-succes">
              <p >
                Bravo compte validé avec succès, vous pouvez maintenant explorer toutes
                les fonctionnalités de Paxity
              </p>
              <Button
                type="primary"
                size="large"
                className="success-btn mb-1"
                onClick={() => navigate('/dashboard')}
              >
                Naviguer
              </Button>
            </div>
          )}

          <motion.div
            className="new-merchant-buttons mt-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.7, duration: 0.6 }}
          >
            {(!kycVerified || (kycStatus === "NOT_SUBMITTED" || kycStatus === "REJECTED")) && (
              <Button
                type="primary"
                size="large"
                className="mb-1"
                onClick={() => setKycModal(true)}
              >
                Lancer la vérification d’identité
              </Button>
            )}

            <Button size="large" onClick={logout} style={{ marginTop: 20 }}>
              Se déconnecter
            </Button>
          </motion.div>

        </Col>
      </Row>

      <AddDocVerify
        modal={kycModal}
        currentUser={currentUserState}
        onUpdateMerchantKyc={(updatedUser) => setCurrentUserState(updatedUser)}
        toggle={() => setKycModal(!kycModal)}
      />
    </div>
  );
};

export default NewMerchant;